import { Outlet, createFileRoute } from "@tanstack/react-router"

export const Route = createFileRoute("/_layout/flashcards")({
  component: FlashcardsLayout,
})

function FlashcardsLayout() {
  return <Outlet />
}
